<div class="d-flex align-items-center justify-content-center min-vh-100 bg-light">
  <div class="card shadow-lg border-0 rounded-4 overflow-hidden"
    style="max-width: 900px; width: 100%; border-radius: 1.5rem;">
    <div class="row g-0">
      <!-- Left Illustration -->
      <div class="col-md-6 d-none d-md-block">
        <img src="assets/img/login_left.png" class="img-fluid h-100 w-100 object-fit-cover" alt="Login illustration">
      </div>

      <!-- Right Login Form -->
      <div class="col-md-6 bg-white p-5">
        <!-- Logo -->
        <div class="text-center mb-4" style="margin: 30px 0 !important;">
          <img src="assets/img/unisoft_logo.png" alt="UniSoft" height="60">
        </div>

        <h4 class="text-center text-secondary mb-4" style="font-weight: 700;">Hệ thống xác thực tập trung</h4>
        <form [formGroup]="loginForm" >
          <!-- Username -->
          <div class="mb-3 position-relative">
            <!-- Icon nằm trong input -->
            <i class="fa fa-user text-primary position-absolute" style="top: 10px; left: 10px;"></i>
            <input type="text" style="padding-left: 30px;" class="form-control rounded-pill ps-5"
              placeholder="Tài khoản" formControlName="UserName" name="username" required>
          </div>


          <!-- Password -->
          <div class="mb-3 position-relative">
            <!-- Icon lock bên trái -->
            <i class="fa fa-lock text-primary position-absolute" style="top: 10px; left: 10px;"></i>

            <!-- Input -->
            <input style="padding-left: 30px; padding-right: 30px;" [type]="showPassword ? 'text' : 'password'"
              class="form-control rounded-pill ps-5 pe-5" placeholder="Mật khẩu" formControlName="Password" name="password"
              required>

            <!-- Eye toggle bên phải -->
            <button type="button" class="btn position-absolute p-0 border-0 bg-transparent"
              style="top: 8px; right: 12px;" (click)="togglePassword()">
              <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash text-primary' : 'fa-eye text-primary'"></i>
            </button>
          </div>


          <!-- Remember + forgot -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" name="rememberMe">
              <label class="form-check-label">Duy trì đăng nhập</label>
            </div>
            <a [routerLink]="['/reset-password']" class="text-decoration-none text-primary">Quên mật khẩu?</a>
          </div>

          <!-- Submit -->
          <button (click)="logIn()" type="submit" class="btn w-100 mb-3 rounded-pill text-white gradient-btn-login">
            Đăng nhập
          </button>


          <!-- Divider -->
          <!-- <div class="d-flex align-items-center mb-3">
            <hr class="flex-grow-1">
            <span class="mx-2 text-muted small">hoặc</span>
            <hr class="flex-grow-1">
          </div> -->

          <!-- Google -->
          <!-- <button type="button" class="btn btn-outline-secondary w-100 rounded-pill">
            <i class="fab fa-google me-2"></i> Đăng nhập bằng Google
          </button> -->
        </form>



        <!-- Language -->
        <!-- <div class="text-center mt-4 small text-muted">
          <i class="fa fa-globe"></i>
          <a href="#" class="text-decoration-none ms-1">Tiếng Việt</a> | 
          <a href="#" class="text-decoration-none">English</a>
        </div> -->
      </div>
    </div>
  </div>
</div>